import React from "react";
import PropTypes from "prop-types";

const IconPlay = (props) => {
  return (
    <svg
      width={props.width ? props.width : "41"}
      height={props.height ? props.height : "41"}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.3361 16.8709L18.6486 11.7459C18.4556 11.6171 18.2312 11.5431 17.9995 11.5319C17.7678 11.5207 17.5373 11.5726 17.3328 11.6821C17.1282 11.7916 16.9572 11.9546 16.8381 12.1537C16.719 12.3528 16.6561 12.5805 16.6562 12.8125V23.0625C16.6561 23.2945 16.719 23.5222 16.8381 23.7213C16.9572 23.9204 17.1282 24.0834 17.3328 24.1929C17.5373 24.3024 17.7678 24.3543 17.9995 24.3431C18.2312 24.3319 18.4556 24.2579 18.6486 24.1291L26.3361 19.0041C26.5118 18.8872 26.656 18.7286 26.7556 18.5425C26.8553 18.3564 26.9075 18.1486 26.9075 17.9375C26.9075 17.7264 26.8553 17.5186 26.7556 17.3325C26.656 17.1464 26.5118 16.9878 26.3361 16.8709ZM19.2188 20.6682V15.2148L23.3155 17.9375L19.2188 20.6682ZM34.5938 6.40625H6.40625C5.72663 6.40625 5.07485 6.67623 4.59429 7.15679C4.11373 7.63735 3.84375 8.28913 3.84375 8.96875V26.9062C3.84375 27.5859 4.11373 28.2376 4.59429 28.7182C5.07485 29.1988 5.72663 29.4688 6.40625 29.4688H34.5938C35.2734 29.4688 35.9251 29.1988 36.4057 28.7182C36.8863 28.2376 37.1562 27.5859 37.1562 26.9062V8.96875C37.1562 8.28913 36.8863 7.63735 36.4057 7.15679C35.9251 6.67623 35.2734 6.40625 34.5938 6.40625ZM34.5938 26.9062H6.40625V8.96875H34.5938V26.9062ZM37.1562 33.3125C37.1562 33.6523 37.0213 33.9782 36.781 34.2185C36.5407 34.4588 36.2148 34.5938 35.875 34.5938H5.125C4.78519 34.5938 4.4593 34.4588 4.21902 34.2185C3.97874 33.9782 3.84375 33.6523 3.84375 33.3125C3.84375 32.9727 3.97874 32.6468 4.21902 32.4065C4.4593 32.1662 4.78519 32.0312 5.125 32.0312H35.875C36.2148 32.0312 36.5407 32.1662 36.781 32.4065C37.0213 32.6468 37.1562 32.9727 37.1562 33.3125Z"
        fill="#F9B233"
      />
    </svg>
  );
};

IconPlay.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default IconPlay;
